import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    deleteSettings,
    updateSettings as addScheduleAction,
    clearUpdateSettings as clearAddAction,
    clearDeleteSettings
} from '../../../actions/settings';
import ScheduleAddModal from './ScheduleAddModal';
import ConfirmModal from '../../common/ConfirmModal'
import { Table } from './ScheduleTable';
import moment from 'moment';

import { schedule } from '../../../constants/settingTypes';
import * as permissions from '../../../constants/permissions';

let Schedule = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            confirmModalShow: false,
            sheduleToDelete: null
        }

        this._load = this._load.bind(this);
        this._addSchedule = this._addSchedule.bind(this);
        this._addModalClose = this._addModalClose.bind(this);
        this._onDeleteClick = this._onDeleteClick.bind(this);
        this._onDeleteCanceled = this._onDeleteCanceled.bind(this);
        this._onDeleteConfirmed = this._onDeleteConfirmed.bind(this);
    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(schedule);
    }

    _addSchedule() {
        this.setState({ showAddModal: true });
    }

    _addModalClose() {
        this.setState({ showAddModal: false });
        this.props.clearAddAction(schedule);
    }

    _onDeleteClick(scheduleToDelete) {
        this.setState({ scheduleToDelete, confirmModalShow: true });
    }

    _onDeleteCanceled() {
        this.setState({ scheduleToDelete: null, confirmModalShow: false });
        this.props.clearDeleteSettings(schedule);
    }

    _onDeleteConfirmed() {
        this.props.deleteSettings(schedule, { Date: this.state.scheduleToDelete.Date });
    }

    render() {
        const { schedule: { data, fetching, deleteFetching } } = this.props;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        return (
            <Panel>
                <Panel.Heading >
                    <span>Выходные</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._addSchedule} />
                </Panel.Heading>
                <Panel.Body className='schedule-table'>
                    <Table
                        fetching={fetching}
                        schedule={data}
                        onDelete={this._onDeleteClick}
                        isReadOnly={isReadOnly} />

                    {this.state.showAddModal && <ScheduleAddModal onClose={this._addModalClose} />}
                    {this.state.confirmModalShow &&
                        <ConfirmModal
                            onYes={this._onDeleteConfirmed}
                            onNo={this._onDeleteCanceled}
                            fetching={deleteFetching}
                            message={`Удалить расписание на дату ${moment(this.state.scheduleToDelete.Date).format('DD.MM.YYYY')}?`}
                            title="Вы уверены?"
                            show={true} />}
                </Panel.Body>
            </Panel>
        );
    }
}

Schedule = connect(state => ({
    schedule: state.application.get('settings')[schedule]
}), { getSettings, deleteSettings, addScheduleAction, clearAddAction, clearDeleteSettings })(Schedule);

export default Schedule;




// WEBPACK FOOTER //
// ./src/components/settings/schedule/Schedule.jsx